/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import TableHeading from '../../../../components/common/Table/TableHeading/TableHeading'
import Container from '../../../common/Container/Container'

/**
 * Class for the ClientTable header
 *
 * @export
 * @class ClientsTableHeader
 * @extends {React.Component<any, any>}
 */
export default class ClientsTableHeader extends React.Component<any, any> {

    /**
     * Creates an instance of ClientsTableHeader.
     * @param {*} props
     * @memberof ClientsTableHeader
     */
    constructor(props: any) {
        super(props)

        this.state = {
            page: 1,
            perPage: 20,
            sortedBy: 'clientName',
            sortedType: 'asc',
        }
    }

    /**
     * Trigger fot the header filters
     *
     * @memberof ClientsTableHeader
     * @param {Object} params
     */
    filterTrigger = (params: object) => {
        this.props.filterTrigger(params)
        this.setState(params)
    }

    render() {

        /**
         * List of headings
         * @type {Array}
         */
        let listHeadings = (this.props.dataType === 'quotes') ?
            [
                { title: 'Client Name', param: 'clientName' },
                { title: 'Inception date', param: 'inceptionDate' },
                { title: 'Date quoted', param: 'quotedDate' },
                { title: 'Days valid', param: 'daysValid' },
            ] :
            this.props.dataType === 'renewals' ?
                [
                    { title: 'Client Name', param: 'clientName' },
                    { title: 'Inception date', param: 'inceptionDate' },
                    { title: 'Date quoted', param: 'quotedDate' },
                    { title: 'Days valid', param: 'daysValid' },
                ] :
                [
                    { title: 'Client Name', param: 'clientName' },
                    { title: 'Inception date', param: 'inceptionDate' },
                    { title: 'Policy no.', param: 'policyNumber' },
                    { title: 'Premium', param: 'premium' },
                ]

        return (

            <Container
                className={`clients__headings table__headings
                ${this.props.showFromSearchPage ? ` searchPageHeader` : ``} ${this.state.sortedBy}`}
                fullwidth={true}
                shadow={true}
            >

                <div />
                {listHeadings.map((heading, i) => (
                    <TableHeading
                        key={i}
                        noMargin={(this.props.dataType === 'policies')}
                        title={heading.title}
                        param={heading.param}
                        state={this.state}
                        filterTrigger={this.filterTrigger}
                    />
                ))}

                <div className="table__title column center">Actions</div>

            </Container>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Clients/components/ClientsTableHeader.tsx